import { useCallback } from "react";

import type { InputMaybe } from "@/lib/gql/__generated__/graphql";

import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	saleStartBeforeDate: ForNodeType<InputMaybe<number> | undefined> | undefined;
	onSetViewModel: (
		values: {
			key: "saleStartBeforeDate";
			value: ForNodeType<InputMaybe<number> | undefined> | undefined;
		}[],
	) => void;
};

export const usePlanSaleStartBeforeDate = ({ saleStartBeforeDate, onSetViewModel }: Props) => {
	const onSetSaleStartBeforeDate = useCallback(
		(input: number | undefined) => {
			onSetViewModel([
				{
					key: "saleStartBeforeDate",
					value: {
						isEdited: true,
						value: input,
					},
				},
			]);
		},
		[onSetViewModel],
	);

	return { saleStartBeforeDate, onSetSaleStartBeforeDate };
};
